import { React, useState, useEffect } from "react";
import { RightLayoutContainer, PageTitleComp, DetailFields, ProfilePort } from "../../styledElements";
import styled from "styled-components";
import { Button, Row, Col, Form, Input, PageHeader } from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { HaberForm } from "../../styledElements";
import CountryPhoneInput, { ConfigProvider } from 'antd-country-phone-input';
import en from 'world_countries_lists/data/countries/en/world.json';
import 'antd-country-phone-input/dist/index.css';
import 'flagpack/dist/flagpack.css';
import DefaultProfilePicture from "../../../Assets/Images/default-pic.png";
import { useNavigate, useLocation } from "react-router-dom";
import { getProfile } from "../../../Services/profileServices";
import { getImageURL } from "../../../Services/deckleMatchServices";

const ProfileViewData = (props) => {
    const [profile, setProfile] = useState();
    const history = useNavigate();
    const companyDetails = JSON.parse(localStorage.getItem("company"));

    useEffect(() => {
  const fetchProfile = async () => {
    try {
      const resp = await getProfile();
      let profileData = resp.data.data;

      if (profileData.profile_picture) {
        const res = await getImageURL({
          bucket_key: profileData.profile_picture,
          operation: "download",
        });
        profileData = { ...profileData, profile_picture: res };
      }

      setProfile(profileData);
    } catch (err) {
      console.error("Error fetching profile:", err);
    }
  };

  fetchProfile();
}, []);


    const getFlag = (short) => {
        const data = require(`world_countries_lists/data/flags/24x24/${short.toLowerCase()}.png`);
        // for dumi
        if (typeof data === 'string') {
            return data;
        }
        // for CRA
        return data.default;
    };
    return (
        profile ?
            <RightLayoutContainer>
                <PageTitleComp>
                    <PageHeader
                        ghost={false}
                        title="General Details"
                        extra={[
                            <Button key="1" onClick={() => { history(`../general-edit`) }} className="themeBtn"><Iconmoon icon="edit" size={14} color="#ffffff" />Edit Profile</Button>,
                        ]}
                    ></PageHeader>
                </PageTitleComp>
                <DetailFields>
                    <HaberForm>
                        <div className="groupDetailWrap profileWraped">
                            <ProfilePort>
                                <div className="bioPic">
                                    <div className="bio-picImg">
                                        <img src={profile.profile_picture?`${profile.profile_picture}`:DefaultProfilePicture} alt="Profile Name" />
                                    </div>
                                    <div className="bio-data">
                                        <h5>{profile.name}</h5>
                                        {companyDetails && companyDetails.business_name &&  <label>{companyDetails.business_name}</label>}
                                    </div>
                                </div>
                            </ProfilePort>
                            <Form name="basic" autoComplete="off" className="haberLogin">
                                <Row gutter={[16, 16]} className="groupForm">
                                    <Col span={24}>
                                        <Row className="centerAlign">
                                            <Col span={10}>
                                                <div className="boxFieldTitle">
                                                    <label>Name</label>
                                                    <p>The name by which you would like to be know to your colleagues</p>
                                                </div>
                                            </Col>
                                            <Col span={10}>
                                                <div className="boxFormType">
                                                    <Form.Item name="name"
                                                        rules={[{}]}
                                                        className=""
                                                        initialValue={profile.name}
                                                    >
                                                        <Input placeholder="Enter the name" disabled />
                                                    </Form.Item>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row className="centerAlign">
                                            <Col span={10}>
                                                <div className="boxFieldTitle">
                                                    <label>Contact Number<span>(Optional)</span></label>
                                                    <p>The primary contact number to reach out to you</p>
                                                </div>
                                            </Col>
                                            <Col span={10}>
                                                <div className="boxFormType">
                                                    <ConfigProvider
                                                        locale={en}
                                                        areaMapper={(area) => {
                                                            return {
                                                                ...area,
                                                                emoji: (
                                                                    <img
                                                                        alt="flag"
                                                                        style={{
                                                                            width: 18,
                                                                            height: 18,
                                                                            verticalAlign: "sub",
                                                                        }}
                                                                        src={getFlag(area.short)}
                                                                    />
                                                                ),
                                                            };
                                                        }}
                                                    >
                                                        <Form.Item
                                                            name="contact"
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: "This field is required",
                                                                },
                                                            ]}
                                                            className=""
                                                            initialValue={{
                                                                short:
                                                                    profile.contact_number?.substring(
                                                                        0,
                                                                        profile.contact_number.indexOf(
                                                                            "-"
                                                                        )
                                                                    ),
                                                                phone:
                                                                    profile.contact_number?.substring(
                                                                        profile.contact_number.indexOf(
                                                                            "-"
                                                                        ) + 1
                                                                    ),
                                                            }}
                                                        >
                                                            <CountryPhoneInput
                                                                className="intlPhone"
                                                                placeholder="Enter the alternate contact number"
                                                                // defaultValue={{ short: "IN" }}
                                                                initialValue={
                                                                    profile?.contact_number
                                                                }
                                                                disabled
                                                            />
                                                        </Form.Item>
                                                    </ConfigProvider>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row className="centerAlign">
                                            <Col span={10}>
                                                <div className="boxFieldTitle">
                                                    <label>Email Address</label>
                                                    <p>The registered email id to access the product</p>
                                                </div>
                                            </Col>
                                            <Col span={10}>
                                                <div className="boxFormType">
                                                    <Form.Item name="email"
                                                        rules={[{ required: true, type: 'email' }]}
                                                        className=""
                                                        initialValue={profile.email}
                                                    >
                                                        <Input placeholder="Enter the email id" disabled/>
                                                    </Form.Item>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row className="centerAlign">
                                            <Col span={10}>
                                                <div className="boxFieldTitle">
                                                    <label>Department<span> (Optional)</span></label>
                                                    <p>Primary department you are associated with</p>
                                                </div>
                                            </Col>
                                            <Col span={10}>
                                                <div className="boxFormType">
                                                <Form.Item name="department"
                                                        rules={[{}]} className=""
                                                        initialValue={profile.department}
                                                    >
                                                        <Input placeholder="Enter the Department" disabled/>
                                                    </Form.Item>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>


                            </Form>
                        </div>
                    </HaberForm>
                </DetailFields>
            </RightLayoutContainer> : <></>
    )
}

export default ProfileViewData;